import type { ActorType } from 'BlockList/types';

/**
 * Pure formatter: ActorType → display string. Returns `null` for unknown
 * runtime values so callers can fall back gracefully under version skew.
 *
 * TODO(RVL-future): when a portal-user lookup lands, expand this helper to
 * accept the id and resolve the display name for the 'portal_user' branch.
 */
export const formatCreatedBy = (type: ActorType): string | null => {
  switch (type) {
    case 'system':
      return 'System (TMX)';
    case 'partner':
      return 'Partner';
    case 'portal_user':
      return 'Portal User';
    default:
      return null;
  }
};
